/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useFlags } from "launchdarkly-react-client-sdk";
import { TierList } from "@/src/utils/type";

import OrderBtn from "../../../components/OrderBtn";

import { getTiers } from "../../../services/services";

import { formatDate, sortTierList } from "../../../utils";
import { Bag } from "../../../assets";

const CategoryHistory: React.FC = () => {
  const { apiDomain } = useFlags();
  const [tiers, setTiers] = useState<TierList[]>([]);
  const [elegible, setElegible] = useState<boolean>(true);

  const [tiersAsc, setTiersAsc] = useState<TierList[]>([]);
  const [tiersDesc, setTiersDesc] = useState<TierList[]>([]);
  const [tiersOrder, setTiersOrder] = useState("desc");
  const [numberItensToShow, setNumberItensToShow] = useState<number>(4);

  const [isLoaded, setIsLoaded] = useState(true);
  const { t } = useTranslation("my_account");

  const getTierData = async () => {
    const responseTierData = await getTiers(apiDomain);
    setTiers(responseTierData.tierList);
    setElegible(responseTierData?.userInfo?.showUpgrade);
    setIsLoaded(true);
  };

  const handleSelectOrder = (index: number) => {
    if (index === 0) {
      setTiersOrder("desc");
      return;
    }
    setTiersOrder("asc");
  };

  const handleShowMoreInfo = () => {
    setNumberItensToShow(numberItensToShow + 4);
  };

  useEffect(() => {
    getTierData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    setTiersAsc(sortTierList("asc", tiers));
    setTiersDesc(sortTierList("desc", tiers));
  }, [tiers]);

  return (
    <>
      {isLoaded && (
        <div className="container-history-table" id="history">
          <div className="history-table">
            <div className="categories__top">
              <h4>{t("my_category.my_history")}</h4>
              {elegible && (
                <div className="categories__btns">
                  <OrderBtn handleSelectOrder={handleSelectOrder} />
                </div>
              )}
            </div>
            {!elegible && (
              <div className="history-table__empty">
                <img className="logo" src={Bag} alt={t("alt")} />
                <div className="history-table__empty__texts">
                  <h3 className="history-table__empty__title">{t("my_category.empty_title")}</h3>
                  <p className="history-table__empty__text">{t("my_category.empty_text")}</p>
                </div>
              </div>
            )}
            {elegible && (
              <div className="history-table__labels">
                <span className="history-table__label link--card">{t("my_category.category")}</span>
                <span className="history-table__label link--card">{t("my_category.start_date")}</span>
                <span className="history-table__label link--card">{t("my_category.end_date")}</span>
              </div>
            )}

            {elegible && (
              <div>
                {tiersOrder === "desc"
                  ? tiersDesc?.slice(0, numberItensToShow).map((item) => (
                      <div key={item.name} className="card horizontal flex-wrap h-auto">
                        <div className="row">
                          <div className="card--body" id="categories-mobile">
                            <span className="history-table__label__mobile link--card">{t("my_category.category")}</span>
                            <p className="caption--card">{item.name}</p>
                          </div>
                          <div id="rule" />
                          <div className="card--body" id="start-date-mobile">
                            <span className="history-table__label__mobile link--card">
                              {t("my_category.start_date")}
                            </span>
                            <p className="caption--card">{formatDate(item.startDate)}</p>
                          </div>
                          <div className="card--body" id="end-date-mobile">
                            <span className="history-table__label__mobile link--card">{t("my_category.end_date")}</span>
                            <p className="caption--card">{formatDate(item.endDate)}</p>
                          </div>
                        </div>
                      </div>
                    ))
                  : tiersAsc?.slice(0, numberItensToShow).map((item) => (
                      <div key={item.name} className="card horizontal flex-wrap h-auto">
                        <div className="row">
                          <div className="card--body" id="categories-mobile">
                            <span className="history-table__label__mobile link--card">{t("my_category.category")}</span>
                            <p className="caption--card">{item.name}</p>
                          </div>
                          <div id="rule" />
                          <div className="card--body" id="start-date-mobile">
                            <span className="history-table__label__mobile link--card">
                              {t("my_category.start_date")}
                            </span>
                            <p className="caption--card">{formatDate(item.startDate)}</p>
                          </div>
                          <div className="card--body" id="end-date-mobile">
                            <span className="history-table__label__mobile link--card">{t("my_category.end_date")}</span>
                            <p className="caption--card">{formatDate(item.endDate)}</p>
                          </div>
                        </div>
                      </div>
                    ))}
                <div className="categories__footer">
                  <div className="categories__order">
                    <button
                      className="categories__btn categories__order-btn"
                      type="button"
                      onClick={handleShowMoreInfo}
                      data-testid="show-more-btn"
                    >
                      {t("order.moreInfo")}
                    </button>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      )}
    </>
  );
};

export default CategoryHistory;
